import React from 'react';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';

const formatWeatherLimitType = (field) => {
  return field.split('_').map(word => word.substring(0,1).toUpperCase() + word.substring(1)).join(' ');
}

const formatWeatherLimit = (limit) => {
  let units = '';
  if (limit.name === 'Temperature') units = '°';
  if (limit.name === 'Wind Speed') units = 'm/s';
  if (limit.name === 'Wind Direction') units = '°';
  if (limit.name === 'Precipitation Intensity') units = 'mm/hr';
  
  if (limit.type === 'greaterThan') return `Greater than ${limit.value1} ${units}`;
  if (limit.type === 'lessThan') return `Less than ${limit.value1} ${units}`;
  if (limit.type === 'between') return `Between ${limit.value1} ${units} and ${limit.value2} ${units}`;
}

enum ExtremeValue {
  Min = 'min',
  Avg = 'avg',
  Max = 'max',
}

const formatExtremeValues = (limit, type: ExtremeValue) => {
  return parseFloat(limit.max_value[limit.field + '-' + type].value).toFixed(1);
}

export const WeatherLimitTable = ({ limits }: { limits: any }) => {
  return (
    <Table>
      <Thead>
        <Row>
          <HeadingCell>Position</HeadingCell>
          <HeadingCell>Type</HeadingCell>
          <HeadingCell>Limit</HeadingCell>
          <HeadingCell>Min</HeadingCell>
          <HeadingCell>Avg</HeadingCell>
          <HeadingCell>Max</HeadingCell>
          <HeadingCell centered={true}>Exceedances</HeadingCell>
        </Row>
      </Thead>
      <Tbody>
        {limits.map((limit, index) => (
          <Row>
            <Cell>{index === 0? 'Primary Limit' : 'Limit ' + (index + 1)}</Cell>
            <Cell>{limit.name}</Cell>
            <Cell>{formatWeatherLimit(limit)}</Cell>
            <Cell>{formatExtremeValues(limit, ExtremeValue.Min)}</Cell>
            <Cell>{formatExtremeValues(limit, ExtremeValue.Avg)}</Cell>
            <Cell>{formatExtremeValues(limit, ExtremeValue.Max)}</Cell>
            <Cell centered={true}>{limit.total_exceedances}</Cell>
          </Row>
        ))}
      </Tbody>
    </Table>
  )
}